import React, { useRef, useState } from "react";
import "./Franchise.css";
import Navber from "../../Components/Navber";
import api from "../../Api.js";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function Franchise() {
  const formRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [companyImg, setCompanyImg] = useState([]);
  const [identityImg, setIdentityImg] = useState([]);

  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    phone: "",
    whatsapp_no: "",
    address: "",
    country: "India",
    state: "",
    city: "",
    pincode: "",
    occupation: "",
    experience_years: "",
    reason: "",
    business_name: "",
    gst_number: "",
    business_registration_number: "",
    google_map_link: "",
  });

  const handleFormRefocus = () => {
    formRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validateFile = (file) => {
    const allowedTypes = [
      "image/jpeg",
      "image/png",
      "image/jpg",
      "application/pdf",
    ];

    if (!allowedTypes.includes(file.type)) {
      toast.error("Only PDF or image files are allowed");
      return false;
    }

    if (file.size > 5 * 1024 * 1024) {
      toast.error("File size must be under 5MB");
      return false;
    }

    return true;
  };

  const handleMultipleFiles = (files, setter) => {
    const validFiles = [];
    for (let file of files) {
      if (validateFile(file)) validFiles.push(file);
    }
    setter(validFiles);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (companyImg.length === 0 || identityImg.length === 0) {
      toast.error("Please upload required documents");
      return;
    }

    const data = new FormData();

    Object.entries(formData).forEach(([key, value]) => {
      data.append(key, value);
    });

    companyImg.forEach((file) => {
      data.append("company_img[]", file);
    });

    identityImg.forEach((file) => {
      data.append("identity_img[]", file);
    });

    try {
      setLoading(true);

      const response = await api.post("/franchises/apply", data);

      if (response?.data?.status === true) {
        toast.success("Franchise application submitted successfully!");
        e.target.reset();
        setCompanyImg([]);
        setIdentityImg([]);
      } else {
        toast.error(response?.data?.message || "Submission failed");
      }
    } catch (error) {
      console.error(error);
      toast.error(`${error.response?.data?.errors?.email?.[0]||error.response?.data?.errors?.phone?.[0] || "An error occurred"}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="franchise-page">
      <Navber />
      <ToastContainer />

      {/* HERO */}
      <section className="franchise-hero">
        <div className="hero-overlay">
          <h1 className="hero-title">Become Our Franchise Partner</h1>
          <p className="hero-subtitle">
            Earn <span>10% Commission</span> on every tour booking
          </p>
          <button className="hero-btn" onClick={handleFormRefocus}>
            Join Now
          </button>
        </div>
      </section>

      {/* FORM */}
      <section className="franchise-form-section" ref={formRef}>
        <h2>Apply for Franchise</h2>

        <form className="franchise-form" onSubmit={handleSubmit}>
          <div className="form-grid">
            <input name="full_name" placeholder="Full Name" onChange={handleChange} required />
            <input name="email" type="email" placeholder="Email" onChange={handleChange} required />
            <input name="phone" placeholder="Phone Number" onChange={handleChange} required />
            <input name="whatsapp_no" placeholder="WhatsApp Number" onChange={handleChange} required />

            <input name="business_name" placeholder="Business Name" onChange={handleChange} required />
            <input name="occupation" placeholder="Occupation" onChange={handleChange} />

            <input name="address" placeholder="Address" onChange={handleChange} required />
            <input name="city" placeholder="City" onChange={handleChange} required />
            <input name="state" placeholder="State" onChange={handleChange} required />
            <input name="pincode" placeholder="Pincode" onChange={handleChange} required />

            <input name="gst_number" placeholder="GST Number" onChange={handleChange} />
            <input
              name="business_registration_number"
              placeholder="Business Registration / CIN"
              onChange={handleChange}
            />

            <input
              type="number"
              name="experience_years"
              placeholder="Experience (Months)"
              min="0"
              step="0.5"
              onChange={handleChange}
              required
            />

            <input
              name="google_map_link"
              placeholder="Google Map Location Link"
              onChange={handleChange}
            />
          </div>

          <textarea
            name="reason"
            rows="4"
            placeholder="Why do you want to associate with us?"
            onChange={handleChange}
            required
          />

          <div className="file-inputs">
            <label>
              Company Documents ((Image and Pdf only)Multiple)
              <input
                type="file"
                accept="image/*,.pdf"
                multiple
                onChange={(e) =>
                  handleMultipleFiles(e.target.files, setCompanyImg)
                }
                required
              />
              {companyImg.length > 0 && (
                <small>{companyImg.length} file(s) selected</small>
              )}
            </label>

            <label>
              Identity Proof ((Image and Pdf only)Multiple)
              <input
                type="file"
                accept="image/*,.pdf"
                multiple
                onChange={(e) =>
                  handleMultipleFiles(e.target.files, setIdentityImg)
                }
                required
              />
              {identityImg.length > 0 && (
                <small>{identityImg.length} file(s) selected</small>
              )}
            </label>
          </div>

          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? "Submitting..." : "Submit Application"}
          </button>
        </form>
      </section>
    </div>
  );
}
